var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text && _vm.url)?_c('a',{staticClass:"plugin-home-common-arrow-link",class:( _obj = {}, _obj[("_" + _vm.theme)] = true, _obj ),attrs:{"href":_vm.url}},[_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('icon',{attrs:{"name":"arrow-right","width":"16","height":"16"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }